/* eslint-disable */
<template>
<div class="question">
  <div class="body">
    <div class="body-content">
      <div>{{question.body}}</div>
    </div>
    <div class="body-option">
      <div><textarea rows="3" cols="100%" v-model="user_choice"></textarea></div>
    </div>
  </div>
</div>
</template>

<script>
require('@/assets/css/question.css')
export default {
  name: 'FillQuestion',
  props: ['question'],
  data() {return {user_choice: ''}},
  methods: {
    answer: function(val){
      this.user_choice = val
      this.$emit('answer', this.question.id, val)
    }
  },
  watch: {
    user_choice: function(newVal, oldVal){
      this.answer(newVal)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/template/question/FillQuestion.vue